module.exports = __webpack_public_path__ + "static/media/battery-jumpstart.a740a581.png";